import Vue from 'vue';
import {
  HelperFunctions
} from "@/lib/utilities/HelperFunctions.js";
import {
  PublishStatus,
  SocialType,
  Category
} from "@/lib/utilities/enums";

function initialState() {
  return {
    Fixed_All_Filters : [],
    DV_All_Filters: [],
    DV_Search_Results: [],
    DV_ActivePlatforms: [],
    DV_Selected_Filters: [],
    DV_JSON: null
  }
}

const state = initialState();

const actions = {

  DV_searchAccounts: function (context, param) {
    return new Promise((resolve, reject) => {
      Vue.http.get('platform/searchdealers?accountId=' + param.accountId + '&term=' + param.searchTxt + '&internalOnly=' + param.interalOnly + '&activeOnly=' + param.activeOnly).then(function (data) {
        data.data.Data.forEach(function (account) {
          account.LabelText = account.Account + " [" + account.AccountId + "]";
        });
        context.commit('update_DV_SearchResults', data.data.Data);
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  load_DV_DealersForAccount: function (context, param) {
    var query;
    if (param.allDealers) {
      query = 'account/allplatforms/' + param.accountId;
    } else {
      query = 'account/platforms/' + param.accountId;
    }
    return new Promise((resolve, reject) => {
      Vue.http.get(query).then(function (data) {
        context.commit('update_DV_Platforms', data.data.Data.sort(HelperFunctions.sortByProperty('Name')));
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  filterPublishRecords: function (context, params) {

    return new Promise((resolve, reject) => {
      Vue.http.post('curator/publishedrecords', params).then(function (data) {
        context.commit('update_DV_JSON', data.data.Data);
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  }
}

const mutations = {
  LoadFilterFieldData: function (state, data) {

    let pubstatus = [],
      category = [],
      types = [],
      postTypes = [{ value: "CURATOR", key: "Curator" }, { value: "FUZECAST", key: "Fuzecast" }];

    for (var status in PublishStatus) {
      pubstatus.push({
        value: PublishStatus[status],
        key: status
      });
    }
    for (var type in SocialType) {
      var name = type.toLowerCase();
      if (name == 'twitter' || name == 'facebook' || name == 'tumblr' || name == 'googleplus' || name == 'blogwp') {
        types.push({
          value: SocialType[type],
          key: type
        });
      }
    }
    for (var cat in Category) {
      category.push({
        value: Category[cat],
        key: cat
      });
    }

    var allfilters = [];
    allfilters.push({
      Id: 1,
      key: 'AccountPlatformID',
      displayText: 'Dealer',
      value: null,
      inputType: 'multiselect'
    }, {
      Id: 2,
      key: 'Id',
      displayText: 'PublishId',
      value: '',
      inputType: 'text'
    }, {
      Id: 3,
      key: 'ArticleID',
      displayText: 'Article Id',
      value: '',
      inputType: 'text'
    }, {
      Id: 4,
      key: 'PublishStatusID',
      displayText: 'Publish Status',
      value: pubstatus,
      inputType: "dropdown"
    }, {
      Id: 5,
      key: 'SocialTypeID',
      displayText: 'Social Type',
      value: types,
      inputType: "dropdown"
      },
      {
        Id: 6,
        key: 'CategoryID',
        displayText: 'Category',
        value: category,
        inputType: "dropdown"
      },
      {
        Id: 7,
        key: 'Title',
        displayText: 'Title',
        value: '',
        inputType: "text"
      },
      {
        Id: 8,
        key: 'PostType',
        displayText: 'Post Type',
        value: postTypes,
        inputType : 'dropdown'
      }
    );
    state.Fixed_All_Filters = JSON.parse(JSON.stringify(allfilters));
    state.DV_All_Filters = allfilters;
    state.SortByItems = ['LastUpdatedDt', 'PublishedDt', 'ScheduleDt', 'CreatedDt'];

  },
  update_DV_FilterFields: function (state, data) {

    if (data.add) {

      var item = state.Fixed_All_Filters.find(x => x.Id == data.Item.Id);
      if(item)
        data.Item.value = item.value;
      state.DV_All_Filters.push(data.Item);
    } else {
      var index = state.DV_All_Filters.findIndex(x => x.Id == data.Item.Id);
      state.DV_All_Filters.splice(index, 1);
    }

  },
  update_DV_SearchResults: function (state, data) {
    state.DV_Search_Results = data;
  },
  update_DV_Platforms: function (state, data) {
    state.DV_ActivePlatforms = data;
  },
  update_DV_SelectedFilters: function (state, data) {

    if (data.add) {
      state.DV_Selected_Filters.push(data.Item);
    } else {
      var index = state.DV_Selected_Filters.findIndex(x => x.Id == data.Item.Id);
      state.DV_Selected_Filters.splice(index, 1);
    }
  },
  update_DV_JSON: function (state, data) {
    state.DV_JSON = data;
  }

}

const getters = {
  Fixed_All_Filters: function () {
    return state.Fixed_All_Filters;
  },
  DV_All_Filters: function () {
    return state.DV_All_Filters;
  },
  DV_Search_Results: function () {
    return state.DV_Search_Results;
  },
  DV_ActivePlatforms: function () {
    return state.DV_ActivePlatforms;
  },
  DV_Selected_Filters: function () {
    return state.DV_Selected_Filters;
  },
  DV_JSON: function () {
    return state.DV_JSON;
  }


}

export default {
  actions,
  mutations,
  getters,
  state
}


// WEBPACK FOOTER //
// ./src/store/modules/DataViewer.js